import type * as RFP from 'react-facebook-pixel';

const voidFn = () => void 0;
const MockFacebookPixel = {
  init: voidFn,
  pageView: voidFn,
  track: voidFn,
  trackCustom: voidFn,
  trackSingle: voidFn,
  trackSingleCustom: voidFn,
  fbq: voidFn,
  revokeConsent: voidFn,
  grantConsent: voidFn,
};

export const FacebookPixel: typeof RFP =
  typeof window === 'undefined'
    ? MockFacebookPixel
    : // eslint-disable-next-line @typescript-eslint/no-var-requires
      require('react-facebook-pixel').default;
